import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { requestHookCache } from '@/context/Provider';
import { getUnionPaySDK } from '@/channels/sdk';
import { clearLocalStoreAndAdrress } from './useStore';
import { clearPrivacySessions } from '@/pages/Privacy/config';

export function useAppClearCacheRegister() {
  const navigate = useNavigate();
  useEffect(() => {
    console.info('[useAppClearCacheRegister] register.');
    getUnionPaySDK()?.registerLifecycle({
      onAppHide: () => {
        console.info('[useAppClearCacheRegister] onAppHide run.');

        requestHookCache.clear();
        clearLocalStoreAndAdrress();
        clearPrivacySessions();

        // rest router
        try {
          if (typeof history !== 'undefined') {
            const len = history.length;
            if (len > 0) {
              navigate(-len);
            }
          }
          navigate('/', { replace: true });
        } catch (error) {
          // ignore
        }
      },
    });
  }, [navigate]);
}
